// extracted by mini-css-extract-plugin
export var circle = "Circle-module--circle--1n3dd";
export var outro = "Circle-module--outro--lfCDY";
export var server = "Circle-module--server--3zL2o";
export var serverCircle = "Circle-module--serverCircle--rmW9E";